<template>
    <div class="task-prop task-prop-priority">
        <strong>Приоритет:</strong>

        <div class="priority-slider">
            <div class="priority-slider__range">
                <span>высокий</span>
                <span>низкий</span>
            </div>

          <VueSlider
              v-model="editable"
              :disabled="disable"
              v-on:drag-end="update()"
              v-on:change="update()"
              :data='allowedPriority'
              :marks="true"
          />
        </div>
    </div>
</template>

<script>
const allowed = Object.keys([...Array(9)]).map(n => 1 + Number(n));

export default {
    name: "Priority",
    components: {
        VueSlider: window.VueSlider,
    },
    props: {
        value: {
            validator(value) {
                return allowed.includes(value);
            }
        },
        disable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            editable: this.value,
            updatedValue: null,
            timer: null
        }
    },
    computed: {
        allowedPriority() {
            return allowed;
        },
    },
  methods: {
      update() {
          if (this.timer) {
              clearTimeout(this.timer);
              this.timer = null;
          }
          this.timer = setTimeout(() => {
            this.updatedValue = this.editable;
            this.$emit('update', this.updatedValue);
          }, 500);
      }
  }
}
</script>

<style lang="scss">
@import "/resources/scss/modules/form/slider";

.task-prop.task-prop-priority {
    display: block;
}

.priority-slider {
    max-width: calc(100% - 20px);
    margin: 0 10px;
    padding-bottom: 30px;

    &__range {
        display: flex;
        justify-content: space-between;
        margin-left: -10px;
        margin-right: -10px;
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
        color: #000000;
    }
}
</style>
